import UserForm from "./UserForm";
import { newUserSchema } from "../../validations/UserValidation";

export default function UserCreate() {
  const initialValues = {
    name: "",
    lastName: "",
    email: "",
    phone: "",
    username: "",
    role: "",
    password: "",
    confirmationPassword: "",
  };

  return (
    <UserForm
      title="Agregar usuario"
      initialValues={initialValues}
      validationSchema={newUserSchema}
      newUser={true}
    />
  );
}
